import React, { type ReactElement } from 'react';
import { createPortal } from 'react-dom';

import BottomSheet, { type BottomSheetProps } from './BottomSheet';
import { useBottomSheetPortal } from './BottomSheetProvider';

const BottomSheetPortal = (props: BottomSheetProps): ReactElement | null => {
    const portalContainer = useBottomSheetPortal();

    if (!portalContainer) {
        return null;
    }

    return createPortal(<BottomSheet {...props} />, portalContainer);
};

export default BottomSheetPortal;
